import React from 'react'
import { ShieldCheck, Settings } from 'lucide-react';

const ServiceGrid = () => {

  return (
    <React.Fragment>
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6">
          <div className="mb-16">
            <h2 className="serif-heading text-3xl font-bold text-navy-950 mb-2">Our Core Expertise</h2>
          </div>

          <div className="grid md:grid-cols-2 gap-12">
            <div className="group p-8 rounded-xl border border-slate-100 hover:shadow-xl transition-all duration-300">
              <div className="mb-6 inline-flex p-3 bg-navy-900 rounded-lg">
                <ShieldCheck className="w-32 h-32" />
              </div>
              <h3 className="serif-heading text-2xl font-bold text-navy-900 mb-2">Strategic Modernization</h3>
              <p className="text-sm font-semibold text-slate-400 uppercase tracking-widest mb-6">For: Large Property & Casualty Insurers, Banks.</p>

              <p className="text-slate-600 mb-8 leading-relaxed">
                We treat modernization as a business risk exercise. We migrate legacy EJB/WebSphere monoliths to Spring Boot and OpenShift safely, ensuring continuous availability.
              </p>

              <div className="bg-slate-50 p-6 rounded-lg border-l-4 border-navy-900">
                <h4 className="text-xs font-bold text-navy-900 uppercase mb-2">Key Capability</h4>
                <p className="text-navy-950 font-medium">"Usage Discovery" via OpenRewrite.</p>
              </div>
            </div>

            <div className="group p-8 rounded-xl border border-slate-100 hover:shadow-xl transition-all duration-300">
              <div className="mb-6 inline-flex p-3 bg-codegreen rounded-lg">
                <Settings className="w-32 h-32" />
              </div>
              <h3 className="serif-heading text-2xl font-bold text-navy-900 mb-2">Infrastructure & Automation</h3>
              <p className="text-sm font-semibold text-slate-400 uppercase tracking-widest mb-6">For: Teams needing scalable, self-owned tech.</p>

              <p className="text-slate-600 mb-8 leading-relaxed">
                We build "Infrastructure-as-a-Product." From private Home Lab data centers to automated content pipelines, we build systems you own entirely.
              </p>

              <div className="bg-slate-50 p-6 rounded-lg border-l-4 border-codegreen">
                <h4 className="text-xs font-bold text-codegreen-dark uppercase mb-2">Key Capability</h4>
                <p className="text-navy-950 font-medium">Containerized CI/CD (Docker / Jenkins).</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}

ServiceGrid.propTypes = {
}

export default ServiceGrid


